module.exports = __webpack_public_path__ + "static/img/8.07042a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/8.jpg
// module id = n21E
// module chunks = 1